import Easing from '../../vendor/react-native/Animated/Easing';
export default Easing;